import { API_END_POINTS } from "../../constant/config";
import JsonInterceptor from "../../utils/JsonInterceptor";
import { GET_HOME_PAGE_BANNERS } from "../type"

// Fetch Banner
export const fetchHomePageBanners = (query) => async (dispatch) => {
    try {
        const apiEndpoint = `${API_END_POINTS.FETCH_HOME_PAGE_BANNERS}?page=${query.pageNumber}&limit=${query.pageSize}`;
        const response = await JsonInterceptor.get(`${apiEndpoint}`)
        dispatch({
            type: GET_HOME_PAGE_BANNERS,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Upload Banner
export const uploadHomeBanner = (data) => async (dispatch) => {
    const config = {     
        headers: { 'content-type': 'multipart/form-data' }
    }

    try {
        const apiEndpoint = API_END_POINTS.UPLOAD_HOME_PAGE_BANNER;
        const response = await JsonInterceptor.post(`${apiEndpoint}`, data, config)
        return dispatch({
            type: "UPLOAD_HOME_BANNER",
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: "UPLOAD_HOME_BANNER",
                payload: error.response.data,
            });
        }
    }
};

// Update Banner
export const updateStatusHomePageBanner = (data, id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.UPDATE_HOME_PAGE_BANNER_STATUS;
        const response = await JsonInterceptor.put(`${apiEndpoint}/${id}`, data)
        return dispatch({
            type: "UPDATE_HOME_PAGE_BANNER_STATUS",
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: "UPDATE_HOME_PAGE_BANNER_STATUS",
                payload: error.response.data,
            });
        }
    }
};

// Delete Banner
export const deleteHomePageBanner = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.DELETE_HOME_PAGE_BANNER;
        await JsonInterceptor.delete(`${apiEndpoint}/${id}`)
        
        dispatch({
            type: "DELETE_HOME_PAGE_BANNER",
        });
    } catch (error) {
        console.log("error", error);
    }
};